import { createSlice, createSelector } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'



const initialState = {
    entities: {Topics:[], Types:[], Search:""},
    status: 'idle', // idle loading success fail  
    error: null
}



const hsFilterSlice = createSlice({
    name: 'hsfilters',
    initialState,
    reducers: {
        hsFilterTopic(state, action) {
            const {id, value} = action.payload
            let Topics = state.entities.Topics
            const TopicIndex = Topics.indexOf(id);

            if (TopicIndex > -1) {
                if (value === false) {
                    Topics.splice(TopicIndex, 1); // 2nd parameter means remove one item only
                }
            }
            else {
                if (value === true) {
                    Topics.push(id)
                }
            }
            state.entities.Topics = Topics

        },
        hsFilterType(state, action) {
            const {id, value} = action.payload
            let Types = state.entities.Types
            const TypeIndex = Types.indexOf(id);
    
            if (TypeIndex > -1) {
                if (value === false) {
                    Types.splice(TypeIndex, 1); // 2nd parameter means remove one item only
                }
            }
            else {
                if (value === true) {
                    Types.push(id)
                }
            }
            state.entities.Types = Types
        },

        hsFilterSearch(state, action) {
            const {Search} = action.payload
            state.entities.Search=Search
        }
    }
})

export const { hsFilterTopic, hsFilterType, hsFilterSearch } = hsFilterSlice.actions

export default hsFilterSlice.reducer

const selectHSFilterEntities = (state) => state.hsfilters.entities

export const selectHSFilters = createSelector(selectHSFilterEntities, (entities) =>
    Object.values(entities)
)

export const selectHSFiltersRaw = createSelector(selectHSFilterEntities, (entities) =>
    entities
)

export const selectHSFilterById = (state, HSFilterId) => {
    return selectHSFilterEntities(state)[HSFilterId]
}

